import { callIntercom } from 'helpers/intercom-helper';
import segmentHelper from 'helpers/segment-helper';
import { useAuth } from 'hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedLayout = ({ children }) => {
  const { token } = useAuth();
  const location = useLocation();
  if (token == null) {
    segmentHelper.reset();
    callIntercom('shutdown');
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }

  return children;
};
